import { render, staticRenderFns } from "./OrderReportGridViewModal.vue?vue&type=template&id=b24b9796"
import script from "./OrderReportGridViewModal.vue?vue&type=script&lang=js"
export * from "./OrderReportGridViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports